/**
 * Type for objects that have catalogueCoding structure
 */
type DiseaseWithCoding = {
  catalogueCoding?: {
    icd10?: { code: string; system?: string | null } | null;
    icd11?: { code: string; system?: string | null } | null;
  } | null;
};

/**
 * Extracts the disease code from any object with catalogueCoding structure.
 * Prefers ICD-11 code over ICD-10 code, returns empty string if neither is available.
 *
 * @param disease - Any object with catalogueCoding structure (Disease, ActiveDiseaseOption, etc.)
 * @returns The disease code string, preferring ICD-11 over ICD-10
 */
export const getDiseaseCode = (disease?: DiseaseWithCoding): string => {
  return (
    disease?.catalogueCoding?.icd11?.code ||
    disease?.catalogueCoding?.icd10?.code ||
    ""
  );
};
